module.exports = "<svg viewBox=\"0 0 18.5 15.1\" height=\"15.1px\" width=\"18.5px\">\n<polygon class=\"control-svg\" fill=\"#000111\" points=\"9.6,0 4.3,4.2 0,4.2 0,10.9 4.3,10.9 9.6,15.1 \"/>\n<g>\n    <path class=\"control-svg\" fill=\"#000111\" d=\"M18.4,4.4l-2.1,3.1l2.2,3.3h-1.3l-1.1-1.5c-0.2-0.3-0.4-0.6-0.6-1.1l0,0c-0.2,0.3-0.4,0.7-0.6,1.1l-1,1.5\n        h-1.4l2.2-3.3l-2.1-3.1H14l0.9,1.4c0.2,0.3,0.4,0.6,0.6,1.1l0,0c0.2-0.4,0.4-0.7,0.6-1.1l1-1.4H18.4z\"/>\n</g>\n</svg>"


//////////////////
// WEBPACK FOOTER
// ./src/icons/muted.svg
// module id = 344
// module chunks = 0